import React from 'react';

function OpenCircle() {
  /* eslint-disable max-len */
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        fill="transparent"
        stroke="#9CA4AF"
        strokeWidth="2"
        cx="12"
        cy="12"
        r="10"
      />
    </svg>
  );
  /* eslint-enable */
}

export default OpenCircle;
